import * as types from "types/actions/event"

const eventInitialState = {
  event: {},
  stats: {}
}

export default (state = eventInitialState, action) => {
  switch (action.type) {
    case types.EVENT_SET:
      return {
        ...state,
        event: action.event
      }
    case types.EVENT_SET_STATS:
      return {
        ...state,
        stats: action.stats
      }
    case types.EVENT_CLEAR:
      return {
        ...state,
        event: {},
        stats: {}
      }
    case types.EVENT_SPONSORS_MOVE:
      return {
        ...state,
        event: {
          ...state.event,
          sponsors: state.event.sponsors.concat(
            state.event.sponsors.splice(0, 3)
          )
        }
      }
    case types.EVENT_UPDATE_STATS:
      return {
        ...state,
        stats: {
          ...state.stats,
          [action.statName]: state.stats[action.statName] + action.number
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/event.js